import { Component, OnInit } from '@angular/core';
import {LoginService} from '../../login-service'
import Swal from 'sweetalert2';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
@Component({
  selector: 'app-admin-forgotpassword',
  templateUrl: './admin-forgotpassword.component.html',
  styleUrls: ['./admin-forgotpassword.component.scss']
})
export class AdminForgotpasswordComponent implements OnInit {
newPassword:any;
confirmPassword:any;
emailID:any;
tempUsersList: any;
usersList: any;
registerForm: FormGroup;
  constructor(private loginServie:LoginService,private formBuilder: FormBuilder,private router:Router) { }

  ngOnInit() {
    this.GetUsers();
    this.registerForm = this.formBuilder.group({
        emailID: ['',[Validators.required,Validators.email]],
         newPassword: ['', [Validators.required, Validators.minLength(6)]],
         confirmPassword: ['', [Validators.required]]
    }, { 
      validator: this.ConfirmedValidator('newPassword', 'confirmPassword')
    }
    );
 }
 ConfirmedValidator(controlName: string, matchingControlName: string){
    return (formGroup: FormGroup) => {
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];
        if (matchingControl.errors && !matchingControl.errors.confirmedValidator) {
            return;
        }
        if (control.value !== matchingControl.value) {
            matchingControl.setErrors({ confirmedValidator: true });
        } else {
            matchingControl.setErrors(null);
        }
    }
}
get f() { return this.registerForm.controls; }
 GetUsers(){
  
    this.loginServie.GetUsers(3).subscribe(data=>{
        data = JSON.parse(data['_body']);
        this.tempUsersList=JSON.parse(JSON.stringify(data));
        let filterUser=this.tempUsersList.filter(x=>x.email==this.emailID);
        if(filterUser.length>0){
            this.usersList=filterUser[0];
        }
    })

 }
 ResetPassword(){
   this.usersList=[];
   this.emailID=this.registerForm.value.emailID;
   this.GetUsers();
   let filterUser=this.tempUsersList.filter(x=>x.email.toString()==this.emailID.toString());
   if(filterUser.length>0){
       this.usersList=filterUser[0];
   }
   if(filterUser.length>0){
    this.newPassword=this.registerForm.value.newPassword;
         
    const json={
       emailparm:this.usersList.email,
       useridparm:this.usersList.id,
       passwordparm:this.newPassword
    }
  if(this.registerForm.valid){
    this.loginServie.ResetPassword(json).subscribe(data=>{
        Swal.fire("Password changed successfully");
        this.registerForm.value.email="";
        this.registerForm.value.newPassword="";
        this.registerForm.value.confirmPassword="";
        this.router.navigateByUrl("/admin");
    })
   }
  
 }
 else{
  Swal.fire("EmailID is incorrect")
}

}
}
